import React, { useState, useRef } from "react";
import { FiLock, FiEye, FiEyeOff } from "react-icons/fi";

export default function InputPassword(props) {
  
  const [passwordShown, setPasswordShown] = useState(false);

  const changeInputType = () => {
    setPasswordShown(!passwordShown);
  };

  return (
    <div className={`bds-placeholderholder ${props?.noIcon ? '' : 'ps-3'} pe-3 ${props?.errorClass}`}>
     {props?.noIcon ? "" : <FiLock />}
      <input
        type={passwordShown ? "text" : "password"}
        name={props.name}
        placeholder={props?.placeholder}
        className={props?.className}
        required={props?.required}
        onChange={props?.onChange}
        onBlur={props?.onBlur}
      />
      <button type="button" onClick={() => changeInputType()}>
        {!passwordShown ? <FiEye /> : <FiEyeOff />}
      </button>
    </div>
  );
}
